import type { CustomerDetails, OrderValidationErrors } from "../types";

type CustomerDetailsFieldsProps = {
  customer: CustomerDetails;
  errors: OrderValidationErrors;
  onChange: (customer: CustomerDetails) => void;
};

type CustomerField = keyof CustomerDetails;

const fields: Array<{
  key: CustomerField;
  label: string;
  placeholder: string;
  type: "text" | "email" | "tel";
  autoComplete: string;
}> = [
  { key: "name", label: "Namn", placeholder: "För- och efternamn", type: "text", autoComplete: "name" },
  { key: "email", label: "E-post", placeholder: "namn@exempel.se", type: "email", autoComplete: "email" },
  { key: "phone", label: "Telefonnummer", placeholder: "070-123 45 67", type: "tel", autoComplete: "tel" },
];

export function CustomerDetailsFields({ customer, errors, onChange }: CustomerDetailsFieldsProps) {
  return (
    <div className="customer-fields">
      {fields.map((field) => {
        const errorId = `${field.key}-error`;
        const error = errors[field.key];
        const isContactField = field.key === "email" || field.key === "phone";
        const describedBy = error ? errorId : isContactField && errors.contact ? "contact-error" : undefined;

        return (
          <label className={`field field--dark${error || (isContactField && errors.contact) ? " field--invalid" : ""}`} key={field.key}>
            <span>{field.label}</span>
            <span className="field__control">
              <input
                type={field.type}
                value={customer[field.key]}
                onChange={(event) => onChange({ ...customer, [field.key]: event.target.value })}
                placeholder={field.placeholder}
                autoComplete={field.autoComplete}
                aria-invalid={Boolean(error || (isContactField && errors.contact))}
                aria-describedby={describedBy}
              />
            </span>
            {error && <span className="field__error" id={errorId}>{error}</span>}
          </label>
        );
      })}
      {errors.contact && <span className="field__error customer-fields__error" id="contact-error">{errors.contact}</span>}
    </div>
  );
}
